import { API_TICKETS } from "../constants/api";

export default (axios) => ({
    getTasksByUserID(userId) {
        let fd = new FormData()
        fd.append('method', 'getTasksByUserID')
        fd.append('userId', userId)

        return axios.post(API_TICKETS, fd).then(({ data }) => {
            return data.data
        })
    },

    getTaskById(taskId) {
        let fd = new FormData()
        fd.append('method', 'getTaskById')
        fd.append('taskId', taskId)

        return axios.post(API_TICKETS, fd).then(({ data }) => {
            return data.data
        })
    },

    updateStatusById(params) {
        let fd = new FormData()
        fd.append('method', 'updateStatusById')
        fd.append('statusId', params.statusId)
        fd.append('taskId', params.taskId)

        return axios.post(API_TICKETS, fd).then(({ data }) => {
            return data.status
        })
    },

    deleteTask(taskId) {
        let fd = new FormData()
        fd.append('method', 'deleteTask')
        fd.append('taskId', taskId)

        return axios.post(API_TICKETS, fd)
    },

    createComment(params) {
        let fd = new FormData()
        fd.append('method', 'createComment')
        fd.append('userId', params.userId)
        fd.append('taskId', params.taskId)
        fd.append('comment', params.comment)
        fd.append('userName', params.userName)

        return axios.post(API_TICKETS, fd).then(({ data }) => {
            return data.data
        })
    },

    deleteComment(commentId) {
        let fd = new FormData()
        fd.append('method', 'deleteComment')
        fd.append('commentId', commentId)

        return axios.post(API_TICKETS, fd)
    },

    createTask(form) {
        let fd = new FormData()
        fd.append('method', 'createTask')
        fd.append('file', form.file)
        fd.append('comment', form.comment)
        fd.append('priorityId', form.priorityId)
        fd.append('title', form.title)
        fd.append('userId', form.userId)
        fd.append('userName', form.userName)

        return axios.post(API_TICKETS, fd).then(({ data }) => {
            return data.data
        })
    },

    getAllTasks() {
        let fd = new FormData()
        fd.append('method', 'getAllTasks')

        return axios.post(API_TICKETS, fd).then(({ data }) => {
            return data.data
        })
    },
});
